<template>
   <transition name="el-zoom-in-left"> 
  <div class="">
    <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix" style="min-width: 1164px !important"> 
       <el-form-item class="tinp" label="所在货位：">
            <el-select @change="selectchange1" filterable value-key="positioncode" v-model="positionname" clearable placeholder="请选择所在货位" style="width:100%;" auto-complete="off">
              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
            </el-select>
       </el-form-item>
      <el-form-item label="商品编码：" class="tinp">
        <el-input v-model="productCode" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable ></el-input>
      </el-form-item>  
      <!-- <el-form-item label="商品名称：" class="tinp">
        <el-input v-model="productName" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
      </el-form-item>  -->
      <el-form-item label="单据号：" class="tinp">
        <el-input v-model="vbillcode" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable ></el-input>
      </el-form-item> 
	  <el-form-item label="业务日期：" class="tinp searchtime" :class="{iconshow:showicon}">
            <el-date-picker value-format="yyyy-MM-dd" v-model="time" type="date" placeholder="选择日期"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon">
            </el-date-picker>
      </el-form-item>
      <!-- <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div> -->
      <el-button type="primary" class="" size="small" icon="el-icon-search" @click="onParamChange"  v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>  
    </el-form>
   	<div class="tablebox kucun tableboxprint">
      <table style="min-width: 1146px;">
        <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
          <th style="" v-for="head in tableHeads">{{ head.label }}</th>
        </tr>
    
        <tr v-for="(item,index) in tableList" :key="index" v-if="count>0">
          <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">
            <span v-if="head.key!='crkbilllx'">{{item[head.key]}}</span>
            <span v-else-if="item.ninnum<0">商品退货</span>
            <span v-else>{{item[head.key]}}</span>
          </td> 
        </tr>
        <tr v-if="count==0">
          <td colspan="13" style="border:0;background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
        </tr>
      </table>
    </div>
     <!-- fenye start -->
    <div class="block" style="text-align: center;margin:20px auto ">
      <span><el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count"></el-pagination></span>
    </div>
    <!-- fenye end -->
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
  </transition> 
</template>
<script> 
import { getElementsByClassName } from '../../../static/js/getDomByClassName.js'  
export default {
  name: '',
  data() {
    return {
      pageFlag:'',
      OrderType:0,
      flag:false, 
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      vbillcode:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      width: 0, //动态宽度
      page: 1,
      pageSize: 20,
      count: 0,
      conditions: {},
      showicon:false,
      positioncode: '', //货位编码
      positionname: '', //货位名称
      productCode: '', //商品编码
      productName: '', //商品名称
      time: '', //业务日期
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      positionList: [],
      fullscreenLoading: false,
      userInfo: {}, 
      tableHeads: [
      	{
          label: '业务日期',
          key: 'dbilldate'
        },
        {
          label: '单据类型',
          key: 'kcbilllx'
        },
        {
          label: '出入库类型',
          key: 'crkbilllx'
        },
        {
          label: '单据号',
          key: 'vbillcode'
        }, 
        {
          label: '仓库',
          key: 'repertoryname'
        }, 
        {
          label: '货位',
          key: 'rackname'
        },
        {
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },
        {
          label: '入库数量',
          key: 'ninnum'
        },   
        {
          label: '出库数量',
          key: 'noutnum'
        }
      ],  
      tableList: {},
      InterfacePath: ''
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.pageFlag = this.$route.query.pageFlag;
    this.OrderType = this.$route.query.pageFlag;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pageSize");
    sessionStorage.removeItem("kucunlist");
    sessionStorage.removeItem("clocationid");
    sessionStorage.removeItem("Keyword");
    sessionStorage.removeItem("count");
    //console.log("清除session");
  },
  methods: {
  	selectchange1(value) {
      //console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      //console.log("下拉变化事件2" + value.position_code);
      this.positioncode = value.positioncode;
      this.positionname = value.positionname;
      this.page=1;
      //this.getlist();
    },
    cleandataicon() { 
      if (this.time != '') {
        this.showicon = !this.showicon;
      }
      if (this.time == null) {
        this.showicon = false;
      }
      //console.log("打印日期："+this.time);
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.page=1; 
      this.getlist();
      //console.log(this.pageSize);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val;
      //console.log("当前页---:" + this.page);
      //console.log("页码----:" + this.pageSize);
      this.getlist();
    },
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             //console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                //console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow =false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败';
                  this.butflag =false;
                  this.butmsg='知道了'; 
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },   
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.userInfo.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          //console.log("打印货位" + JSON.stringify(this.positionList));
          // this.getlist();
        }else if(res.data.status == '-1'){
            this.positionList = [];
            this.$message({
              showClose:true,
              message:'暂无数据！',
              type:'info'
            })
        } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        }       
      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败';
        this.butflag =false;
        this.butmsg='知道了';  
      });
    }, 
    init() {
      var users = JSON.parse(window.localStorage.getItem("userInfo"));
      if (users != null) {
        this.userInfo = users;
      }
      this.width = document.documentElement.clientWidth - 200;
      
      this.getposition();
      //this.getlist();   
      //console.log("2");
      // }
      // console.log("刷新数据"+JSON.stringify(list));
    },
 
    getlist() { //获取数据
      this.fullscreenLoading = true;
      //搜索参数 
      var reqparam = { 
        positioncode: this.positioncode==undefined?'':this.positioncode, //货位
        positionname: this.positionname==undefined?'':this.positionname, //货位
        productCode: this.productCode==undefined?'':this.productCode, //商品编码
        //productName: this.productName==undefined?'':this.productName, //商品名称
        vbillcode: this.vbillcode==undefined?'':this.vbillcode, //单据号
        time: this.time==undefined?'':this.time, //单据号
        pageNum: this.page,
        pageSize: this.pageSize, 
      };
      
      //console.log("reqpara-=-==m" + JSON.stringify(reqparam))
      this.$http.post(this.utilpath + '/showInBoundDetail', reqparam, { emulateJSON: true})
        // this.$http.post("/ktnapi/selectPresentSock",reqparam,{emulateJSON:true})
        // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true}) 
        .then((res) => {
          if(res.data.status=='0'){ 
              this.fullscreenLoading = false; 
               

              this.tableList = res.data.resultList;  
              
              this.count = res.data.countNum;

              //console.log("打印返回值tableList：" + JSON.stringify(this.tableList)); 
             // console.log("打印数据长度：" + this.count); 
          }else if(res.data.status=='-1'){
              this.fullscreenLoading = false; 
              this.tableList =[];
              this.count =0;
              this.$message({
                  showClose:true,
                  message:'暂无数据！',
                  type:'info'
              })
          } else if(res.data.status == '9'){
          	this.fullscreenLoading = false; 
                this.$router.push({path:'/ui/login',query:{msg:9}});
          } else{
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了'; 
          }
        }, (err) => {
          this.fullscreenLoading = false;
          this.msgShow =false;
            this.modelFlag = true;
            this.methodName = 'message';
            this.msg = '连接获取库存收发流水接口失败';
            this.butflag =false;
            this.butmsg='知道了';
        });
      sessionStorage.setItem("clocationid", this.conditions.input1);
      sessionStorage.setItem("Keyword", this.conditions.input2);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pageSize", this.pageSize);
      sessionStorage.setItem("count", this.count);
    },
    onParamChange(attr, val) { //搜索变更事件 
    	 this.page=1;
      	 this.getlist();  
    }, 
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/receives/reportForms.vue